// Official ANNADATA AI Logo Component with Motion Animation

// Official ANNADATA AI Logo SVG Paths
const logoPaths = {
    leftLeaf: "M705.115,306.202 C717.382,304.885 732.855,306.161 745.002,307.852 C823.45,318.773 893.033,371.713 917.31,448.18 C923.697,468.298 927.945,485.281 923.085,506.161 C917.106,502.221 894.75,475.44 885.902,466.778 C848.628,430.285 822.625,422.676 780.05,401.483 C785.066,406.358 794.831,413.401 800.68,417.886 C839.46,446.109 887.808,505.205 903.615,550.384 C866.105,546.744 817.204,528.756 786.207,507.829 C735.323,473.477 705.132,423.338 693.951,363.348 C691.765,351.618 686.228,320.989 693.499,311.259 C696.457,307.302 700.518,307.048 705.115,306.202 Z",
    rightLeaf: "M946.047,524.11 C947.144,459.327 959.668,382.586 995.278,327.128 C1051.16,240.09 1164.26,216.356 1260.9,226.342 C1269.92,227.274 1283.12,228.095 1290.8,233.214 C1292.62,237.041 1292.55,239.52 1292.63,243.745 C1293.97,313.809 1265.63,380.754 1216.31,430.286 C1171.14,475.654 1115.2,499.138 1053.3,511.509 C1038.48,514.471 1015.72,518.184 1000.71,517.989 L998.993,517.959 C1027.1,428.443 1093.79,363.67 1171.35,314.693 L1170.63,314.225 C1164.2,315.926 1159.22,319.587 1153.25,321.965 C1081.07,350.688 1019.82,407.215 990.29,479.569 C985.912,490.295 981.732,500.099 979.929,511.822 L979.436,512.646 C977.005,516.765 977.221,518.893 974.669,521.518 C970.598,512.851 965.572,512.545 956.83,511.828 C951.416,516.675 950.283,518.311 946.047,524.11 Z",
    stem: "M956.83,511.828 C965.572,512.545 970.598,512.851 974.669,521.518 C977.221,518.893 977.005,516.765 979.436,512.646 L979.929,511.822 C980.09,522.686 978.869,533.179 978.238,544.011 C974.258,612.324 977.565,680.943 979.717,749.277 C980.26,766.499 980.241,783.831 981.065,800.996 C965.2,780.894 973.888,777.023 945.075,773.167 C943.375,764.207 942.745,733.677 942.187,723.09 C938.609,655.172 941.229,591.618 946.047,524.11 C950.283,518.311 951.416,516.675 956.83,511.828 Z",
    leftCircuit: "M833.386,805.956 C832.772,807.19 832.133,808.41 831.467,809.616 C814.696,839.85 780.053,852.227 749.563,834.6 C735.845,826.611 725.924,813.431 722.041,798.039 C718.083,781.678 720.861,764.413 729.75,750.119 C738.277,736.736 751.896,727.411 767.457,724.302 C783.132,721.193 799.4,724.432 812.69,733.308 C827.457,743.356 833.863,755.926 837.207,772.759 C860.768,772.304 884.334,772.166 907.899,772.347 C917.798,772.362 936.067,771.757 945.075,773.167 C973.888,777.023 965.2,780.894 981.065,800.996 C983.549,811.54 982.112,856.071 981.381,867.509 C980.731,877.678 930.671,925.84 921.136,932.23 C926.453,965.423 920.535,994.026 885.031,1006.69 C869.471,1012.08 852.402,1011.02 837.627,1003.75 C824.016,997.098 813.941,986.349 808.994,971.972 C804.061,957.324 805.077,941.325 811.823,927.419 C829.721,890.826 867.042,886.596 900.605,904.224 C910.62,893.465 922.3,883.72 932.615,873.223 C945.422,860.191 944.442,851.908 944.079,835.454 C938.467,826.687 928.456,814.374 921.913,806.177 C894.19,805.21 861.737,806.118 833.386,805.956 Z M785.741,807.281 C799.443,803.773 807.714,789.829 804.223,776.123 C800.732,762.418 786.799,754.13 773.088,757.604 C759.354,761.084 751.048,775.047 754.545,788.777 C758.043,802.507 772.016,810.795 785.741,807.281 Z M868.527,976.656 C882.213,974.774 891.741,962.099 889.747,948.429 C887.753,934.76 875,925.335 861.347,927.441 C847.851,929.523 838.559,942.097 840.53,955.609 C842.501,969.122 854.999,978.517 868.527,976.656 Z",
    rightCircuit: "M1185.91,582.259 C1195.82,581.54 1204.61,581.787 1214.13,584.849 C1228.64,589.472 1240.61,599.867 1247.23,613.589 C1254.52,628.373 1255.63,645.425 1250.01,660.759 C1231.26,711.908 1162.17,711.743 1140.73,663.098 C1111.46,662.982 1082.2,663.247 1052.94,663.894 L1053.09,813.767 C1053.1,841.612 1053.32,869.473 1053.02,897.317 C1052.87,911.317 1048.34,915.314 1039.16,924.857 C1020.56,944.189 1000.5,962.228 982.015,981.652 C981.4,993.064 981.979,1010.07 982.016,1021.9 C1011.59,1021.34 1034.69,1054.06 1032.13,1081.66 C1031.55,1087.88 1030.92,1091.61 1029.34,1097.71 C1009.77,1146.7 942.93,1150.27 918.466,1104.42 C911.248,1091.09 909.671,1075.43 914.088,1060.94 C919.673,1042.69 930.857,1033 947.053,1024.24 C946.229,1015.55 944.637,979.521 947.495,971.968 C958.144,950.105 981.382,933.291 997.593,915.324 C1005.48,906.586 1013.39,901.129 1019.41,891.101 C1020.49,870.978 1019.97,845.372 1019.93,825.018 L1019.8,709.882 C1019.79,687.849 1019.29,664.006 1020.17,642.155 C1023.21,636.707 1026.29,631.491 1032.9,630.71 C1046.25,629.132 1060.74,629.89 1074.19,629.988 L1136.95,630.009 C1145.37,601.818 1156.34,589.123 1185.91,582.259 Z M1200.42,665.401 C1214.35,662.488 1223.34,648.894 1220.56,634.932 C1217.78,620.97 1204.27,611.853 1190.28,614.499 C1176.11,617.18 1166.84,630.912 1169.65,645.065 C1172.47,659.217 1186.29,668.354 1200.42,665.401 Z M977.292,1102.72 C989.871,1100.47 998.87,1089.29 998.396,1076.52 C998.116,1068.98 994.532,1061.95 988.596,1057.29 C982.66,1052.64 974.975,1050.83 967.586,1052.35 C953.838,1055.19 944.921,1068.54 947.577,1082.33 C950.232,1096.11 963.475,1105.2 977.292,1102.72 Z",
    topRightCircuit: "M1190.14,750.252 C1198.31,749.714 1206.51,750.774 1214.28,753.371 C1246.93,764.541 1261.62,800.385 1249.66,831.943 C1237.29,864.596 1202.61,875.275 1171.7,864.105 C1157.58,859.001 1146.1,845.433 1140.21,831.97 L1119,832.041 C1119.41,863.16 1119.59,894.282 1119.55,925.404 C1119.39,956.044 1112.05,957.592 1089.34,980.027 C1077.13,991.901 1049.72,1028.5 1033.34,1015.49 C1015.05,1001.02 1036.36,985.273 1046.02,974.431 C1058.09,960.904 1077.32,945.921 1087.49,931.637 C1088.41,905.556 1087.29,877.891 1087.64,851.662 C1087.79,840.431 1087.27,828.904 1087.88,817.659 C1088.37,808.517 1091.71,806.147 1098.44,800.446 C1098.7,800.41 1098.95,800.374 1099.2,800.338 L1100.47,800.185 C1110.11,798.976 1126.84,799.574 1137.2,799.671 C1144.23,769.022 1160.58,756.659 1190.14,750.252 Z M1201.44,834.638 C1210.5,832.359 1217.63,825.373 1220.1,816.36 C1222.56,807.348 1219.98,797.706 1213.34,791.134 C1206.7,784.561 1197.03,782.077 1188.04,784.634 C1174.44,788.504 1166.46,802.574 1170.12,816.234 C1173.78,829.894 1187.73,838.088 1201.44,834.638 Z",
};

interface LogoProps {
    size?: number | 'sm' | 'md' | 'lg' | 'xl';
    showText?: boolean;
    className?: string;
    /** Enable premium motion animation */
    animated?: boolean;
}

const sizeMap = {
    sm: 42,
    md: 64,
    lg: 88,
    xl: 128,
};

export function Logo({ size = 'md', showText = false, className = '', animated = true }: LogoProps) {
    const pixelSize = typeof size === 'number' ? size : sizeMap[size];

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <svg
                viewBox="680 200 650 1000"
                width={pixelSize}
                height={pixelSize}
                className={`flex-shrink-0 ${animated ? 'logo-animated' : ''}`}
            >
                {/* Glow filter for animation */}
                <defs>
                    <filter id="leafGlow" x="-50%" y="-50%" width="200%" height="200%">
                        <feGaussianBlur stdDeviation="8" result="coloredBlur" />
                        <feMerge>
                            <feMergeNode in="coloredBlur" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                    <filter id="circuitPulse" x="-50%" y="-50%" width="200%" height="200%">
                        <feGaussianBlur stdDeviation="4" result="coloredBlur" />
                        <feMerge>
                            <feMergeNode in="coloredBlur" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>

                {/* Left Large Leaf - Green with sway animation */}
                <path
                    fill="#6bb06b"
                    d={logoPaths.leftLeaf}
                    className={animated ? 'leaf-left' : ''}
                    style={animated ? { transformOrigin: '850px 400px' } : undefined}
                />

                {/* Right Large Leaf - Green with sway animation */}
                <path
                    fill="#6bb06b"
                    d={logoPaths.rightLeaf}
                    className={animated ? 'leaf-right' : ''}
                    style={animated ? { transformOrigin: '1100px 400px' } : undefined}
                />

                {/* Stem - Golden */}
                <path fill="#baaa6c" d={logoPaths.stem} />

                {/* Left Circuit - Blue with pulse animation */}
                <path
                    fill="#275a9a"
                    d={logoPaths.leftCircuit}
                    className={animated ? 'circuit-pulse' : ''}
                />

                {/* Right Circuit - Blue with pulse animation */}
                <path
                    fill="#275a9a"
                    d={logoPaths.rightCircuit}
                    className={animated ? 'circuit-pulse delay-1' : ''}
                />

                {/* Top Right Small Circuit - Blue with pulse animation */}
                <path
                    fill="#275a9a"
                    d={logoPaths.topRightCircuit}
                    className={animated ? 'circuit-pulse delay-2' : ''}
                />
            </svg>

            {showText && (
                <div className="flex flex-col">
                    <span className="text-xl font-bold text-gray-800 dark:text-gray-100 leading-tight">
                        ANNADATA AI
                    </span>
                    <span className="text-xs text-emerald-600 dark:text-emerald-400">
                        अन्नदाता AI
                    </span>
                </div>
            )}

            {/* CSS Keyframe Animations - Injected once */}
            {animated && (
                <style>{`
                    .logo-animated .leaf-left {
                        animation: leafSwayLeft 4s ease-in-out infinite;
                    }
                    .logo-animated .leaf-right {
                        animation: leafSwayRight 4s ease-in-out infinite;
                        animation-delay: 0.5s;
                    }
                    .logo-animated .circuit-pulse {
                        animation: circuitGlow 2s ease-in-out infinite;
                    }
                    .logo-animated .circuit-pulse.delay-1 {
                        animation-delay: 0.3s;
                    }
                    .logo-animated .circuit-pulse.delay-2 {
                        animation-delay: 0.6s;
                    }
                    
                    @keyframes leafSwayLeft {
                        0%, 100% { transform: rotate(0deg); }
                        25% { transform: rotate(-2deg); }
                        75% { transform: rotate(1deg); }
                    }
                    @keyframes leafSwayRight {
                        0%, 100% { transform: rotate(0deg); }
                        25% { transform: rotate(2deg); }
                        75% { transform: rotate(-1deg); }
                    }
                    @keyframes circuitGlow {
                        0%, 100% { 
                            fill: #275a9a;
                            filter: none;
                        }
                        50% { 
                            fill: #3b82f6;
                            filter: url(#circuitPulse);
                        }
                    }
                `}</style>
            )}
        </div>
    );
}

// Simple icon version for compact spaces (no animation)
export function LogoIcon({ size = 24, className = '' }: { size?: number; className?: string }) {
    return (
        <svg
            viewBox="680 200 650 1000"
            width={size}
            height={size}
            className={className}
        >
            <path fill="#6bb06b" d={logoPaths.leftLeaf} />
            <path fill="#6bb06b" d={logoPaths.rightLeaf} />
            <path fill="#baaa6c" d={logoPaths.stem} />
            <path fill="#275a9a" d={logoPaths.leftCircuit} />
            <path fill="#275a9a" d={logoPaths.rightCircuit} />
            <path fill="#275a9a" d={logoPaths.topRightCircuit} />
        </svg>
    );
}

export default Logo;
